/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-props-no-spreading */
import { useEffect } from 'react';

import PropTypes from 'prop-types';
import { Select } from '@telus-uds/components-web';
import { useTranslation } from 'react-i18next';

import useStore from '../../../store/store';
import { getLabel } from '../util';

export default function Input({ fieldData }) {
  const { t } = useTranslation(['form']);
  const { selectedFormValues, setSelectedFormValues } = useStore(
    (state) => state
  );

  const { id, name, options, hint, required, toolTip } = fieldData;
  const { error } = selectedFormValues[name];

  const handleOnChange = (value) => {
    setSelectedFormValues((previousValue) => ({
      ...previousValue,
      [name]: {
        ...previousValue[name],
        value,
        touched: true,
        ...(required && !value
          ? { error: t('labelFieldRequired') }
          : { error: '' }),
      },
    }));
  };

  const fieldProps = {
    label: getLabel(fieldData),
    placeholder: 'Please select an option...',
    ...(hint && { hint, hintPosition: 'below' }),
    ...(error && { validation: 'error', feedback: error }),
    ...(toolTip && { tooltip: toolTip }),
    value: selectedFormValues[name].value,
    onChange: handleOnChange,
  };

  useEffect(() => {
    return () => {
      setSelectedFormValues((previousValue) => ({
        ...previousValue,
        [name]: {
          ...previousValue[name],
          value: '',
        },
      }));
    };
  }, []);

  return (
    <div id={id}>
      <Select {...fieldProps}>
        <Select.Item value="">..</Select.Item>
        {options.map((option) => (
          <Select.Item key={option.sys.id} value={option.fields.value}>
            {option.fields.label}
          </Select.Item>
        ))}
      </Select>
    </div>
  );
}

Input.propTypes = {
  fieldData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    hint: PropTypes.string,
    required: PropTypes.bool,
    toolTip: PropTypes.string,
    error: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string,
        }),
      })
    ),
  }).isRequired,
};
